module.exports = __webpack_public_path__ + "static/media/partner05.fe6a3ac1.svg";